"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformUTCToBookingTime = transformUTCToBookingTime;
const utcToZonedTimeOrDefault_1 = require("../helpers/utcToZonedTimeOrDefault");
function transformUTCToBookingTime(date, timezone) {
    const zonedTime = (0, utcToZonedTimeOrDefault_1.utcToZonedTimeOrDefault)(date, timezone);
    return new Date(Date.UTC(zonedTime.getFullYear(), zonedTime.getMonth(), zonedTime.getDate(), zonedTime.getHours(), zonedTime.getMinutes(), zonedTime.getSeconds()));
}
//# sourceMappingURL=transformUTCToBookingTime.js.map